import { apis, serviceInterface } from "./config";

export const getAllSubindustries = () => {
  return serviceInterface.get(apis.SUBINDUSTRY);
};

export const getSubindustryById = id => {
  return serviceInterface.get(`${apis.SUBINDUSTRY}"/"${id}`);
};
